import { IterationTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/IterationTextMergeElement";
import { BaseTextMergeContainerEditor } from "./Text/BaseTextMergeContainerEditor";
import LoopIcon from "@mui/icons-material/Loop";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseTextMergeContainerElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { Box, TextField } from "@mui/material";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import VariablePicker from "../../CommonUI/VariablePicker/VariablePicker";

export class IterationTextMergeEditor extends BaseTextMergeContainerEditor<IterationTextMergeElement> {
    getIcon(): JSX.Element {
        return <LoopIcon />;
    }

    override renderContent(editContext: TextMergeEditContext, _styles: object): React.ReactNode {
        return (
            <>
                {super.renderContentInternal(editContext)}
                {super.renderContentInternal(editContext)}
                {super.renderContentInternal(editContext)}
            </>
        );
    }

    override renderAbove(
        _element: BaseTextMergeContainerElement,
        _context: TextMergeEditContext,
    ): JSX.Element | undefined {
        return (
            <Box
                marginLeft={"30px"}
                display={"flex"}
                flexDirection={"column"}
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    paddingBottom={"10px"}
                >
                    <UILabel>Path</UILabel>
                    <VariablePicker
                        selected={this.editorData!.path}
                        data={this.editorData!.parent!.getInputData()}
                        isList={true}
                        hideExpectedType={true}
                        onVariableSet={(v) => {
                            this.editorData!.path = v;
                        }}
                    />
                </Box>
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    paddingBottom={"15px"}
                >
                    <UILabel>Item Name</UILabel>
                    <TextField
                        variant={"outlined"}
                        value={this.editorData!.itemName}
                        onChange={(e) => {
                            this.editorData!.itemName = e.target.value;
                        }}
                    />
                </Box>
            </Box>
        );
    }
}
